import React from 'react';
import Modal from '../../component/Inc/Modal';

function PopTeacherTrainingDetail(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} popSize="m">
      <h2 className="pop_tit">신규 교사교육 상세보기</h2>
      <div className="content_container scroll pop_teacher_training">
        <table className="com_board_list type_row layout_fixed">
          <colgroup>
            <col width="130" />
            <col width="210" />
            <col width="130" />
            <col width="210" />
          </colgroup>
          <tbody>
            <tr>
              <th>등록 방법</th>
              <td className="type_row" colSpan={3}>
                <div className="check">
                  <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                  <label htmlFor="rdo_01">신규 등록</label>
                  <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                  <label htmlFor="rdo_02">기존 교육 복사 등록</label>
                </div>
              </td>
            </tr>
            <tr>
              <th>교육 연도</th>
              <td>
                <select className="select">
                  <option value="선택">선택</option>
                </select>
              </td>
              <th>교관</th>
              <td>
                <select className="select">
                  <option value="선택">선택</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>기수</th>
              <td className="type_row" colSpan={3}>
                <div className="com_input_wrap flex_row">
                  <select className="select ws">
                    <option value="선택">선택</option>
                  </select>
                  <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
                  <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
                </div>
              </td>
            </tr>
            <tr>
              <th>총 회차</th>
              <td className="type_row" colSpan={3}>
                <div className="com_input_wrap flex_row">
                  <select className="select ws">
                    <option value="선택">선택</option>
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table className="com_board_list type_row layout_fixed">
          <colgroup>
            <col width="130" />
            <col width="210" />
            <col width="130" />
            <col width="210" />
          </colgroup>
          <tbody>
            <tr>
              <th>1회차 수업일</th>
              <td>
                <input type="date" className="com_datepicker xs" placeholder="2022. 01. 01" />
              </td>
              <th>총 교시</th>
              <td>
                <select className="select">
                  <option value="선택">선택</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <table className="com_board_list type_row layout_fixed">
          <colgroup>
            <col width="130" />
            <col width="210" />
            <col width="130" />
            <col width="210" />
          </colgroup>
          <tbody>
            <tr>
              <th>1교시 시작 시간</th>
              <td>
                <div className="com_input_wrap flex_row time_wrap">
                  <select className="select">
                    <option value="09시">09시</option>
                  </select>
                  <select className="select">
                    <option value="30분">30분</option>
                  </select>
                  <div>부터 ~</div>
                </div>
              </td>
              <th>수업시간</th>
              <td>
                <select className="select">
                  <option value="50분">50분</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>1교시 시작 시간</th>
              <td>
                <div className="com_input_wrap flex_row time_wrap">
                  <select className="select">
                    <option value="09시">09시</option>
                  </select>
                  <select className="select">
                    <option value="30분">30분</option>
                  </select>
                  <div>부터 ~</div>
                </div>
              </td>
              <th>수업시간</th>
              <td>
                <select className="select">
                  <option value="50분">50분</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>1교시 시작 시간</th>
              <td>
                <div className="com_input_wrap flex_row time_wrap">
                  <select className="select">
                    <option value="09시">09시</option>
                  </select>
                  <select className="select">
                    <option value="30분">30분</option>
                  </select>
                  <div>부터 ~</div>
                </div>
              </td>
              <th>수업시간</th>
              <td>
                <select className="select">
                  <option value="50분">50분</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>1교시 시작 시간</th>
              <td>
                <div className="com_input_wrap flex_row time_wrap">
                  <select className="select">
                    <option value="09시">09시</option>
                  </select>
                  <select className="select">
                    <option value="30분">30분</option>
                  </select>
                  <div>부터 ~</div>
                </div>
              </td>
              <th>수업시간</th>
              <td>
                <select className="select">
                  <option value="50분">50분</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopTeacherTrainingDetail;
